import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CreateTaskPage } from '~/modules/dataSyncJobs/CreateTaskPage';

import { buildRouteExport } from '~/utils/buildRouteExport';

const searchSchema = z.object({
  duplicateFrom: z.string().optional(),
});

export const Route = createFileRoute(
  '/(main)/settings/admin/data-sync/$jobId/$taskId_/',
)({
  component: CreateTaskPage,
  validateSearch: searchSchema,
});

export const DATA_SYNC_TASK = buildRouteExport({
  Route,
});
